import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'

const withContainer = Component => ({ row, ...props }) => {
  const group_contactinfo_id = _.get(row, 'group_contactinfo_id')
  const [deleteRecord] = hooks.useModelFunction('groupcontactinfo', 'delete')
  const onDelete = useCallback(() => deleteRecord({ group_contactinfo_id }), [group_contactinfo_id])

  const mergedProps = {
    row,
    onDelete
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
